import { database } from "../firebase";
import * as moment from "moment";
import htmlToDraft from "html-to-draftjs";
import { EditorState, ContentState } from "draft-js";

export const retrieveTemplateDetails = async (info) => {
  try {
    if (info.companyId && info.templateId) {
      const template = await database
        .collection("companies")
        .doc(info.companyId)
        .collection("templates")
        .doc(info.templateId)
        .get();
      if (template.exists) {
        if (template.data().type === "email") {
          const contentBlock = htmlToDraft(template.data().html);
          if (contentBlock) {
            const contentState = ContentState.createFromBlockArray(
              contentBlock.contentBlocks
            );
            const rawContent = EditorState.createWithContent(contentState);
            return {
              error: null,
              payload: {
                id: template.id,
                type: template.data().type,
                title: template.data().title,
                html: template.data().html,
                content: rawContent,
              },
            };
          }
        } else {
          const contentBlock = htmlToDraft(template.data().message);
          if (contentBlock) {
            const contentState = ContentState.createFromBlockArray(
              contentBlock.contentBlocks
            );
            const rawContent = EditorState.createWithContent(contentState);
            return {
              error: null,
              payload: {
                id: template.id,
                type: template.data().type,
                title: template.data().title,
                message: template.data().message,
                content: rawContent,
              },
            };
          }
        }
      } else {
        throw new Error("Malen eksisterer ikke.");
      }
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const updateSingleTemplate = async (details) => {
  try {
    let changedObject = details;
    if (details.type === "email") {
      await database
        .collection("companies")
        .doc(details.companyId)
        .collection("templates")
        .doc(details.templateId)
        .update({
          title: changedObject.template.title,
          html: changedObject.template.html,
          lastUpdated: moment().unix(),
        });
      return { error: null, payload: details.type };
    } else {
      await database
        .collection("companies")
        .doc(details.companyId)
        .collection("templates")
        .doc(details.templateId)
        .update({
          title: changedObject.template.title,
          message: changedObject.template.message,
          lastUpdated: moment().unix(),
        });
      return { error: null, payload: details.type };
    }
  } catch (e) {
    throw new Error(e);
  }
};
